module.exports = __webpack_public_path__ + "img/foam_slicing_1200x800.fc317a8b.svg";